import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import UEditor from "@/components/UEditor/index.vue";
import VRadio from "./VRadio.vue";
import VCheckBox from "./VCheckBox.vue";
let VOption = class VOption extends Vue {
    constructor() {
        super(...arguments);
        this.ueDefaultMsg = '';
        this.optionContent = '';
        this.optionDescrib = '';
        this.answerType = 1;
        this.id = Math.random().toString(16).slice(2);
    }
    get deleteStatus() {
        return !this.isJoinPaper && this.showDelete;
    }
    get name() {
        return String.fromCharCode(65 + this.index);
    }
    get ueditor() {
        return this.editor && this.editor.ue || {};
    }
    handleStatusChange(state) {
        let content = '', describ = '';
        if (this.ueditor) {
            content = this.ueditor.getContent();
            describ = this.ueditor.getPlainTxt();
        }
        this.answerType = state ? 0 : 1;
        this.$bus.$emit("get-option-content", this.index, {
            content,
            describ,
            type: this.answerType,
            id: this.option.id
        });
    }
    getUEContent(content, _, plainText) {
        this.optionContent = content;
        this.optionDescrib = plainText;
        this.$bus.$emit("get-option-content", this.index, {
            content: this.optionContent,
            describ: this.optionDescrib,
            type: this.answerType,
            id: this.option.id
        });
    }
    deleteOption() {
        this.$emit("delete-option", this.index, this.option.id);
    }
};
tslib_1.__decorate([
    Prop({ type: Number, required: true })
], VOption.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({ type: Number, required: true })
], VOption.prototype, "index", void 0);
tslib_1.__decorate([
    Prop({ type: Object, required: true })
], VOption.prototype, "option", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VOption.prototype, "status", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], VOption.prototype, "showDelete", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VOption.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VOption.prototype, "isJoinPaper", void 0);
tslib_1.__decorate([
    Ref()
], VOption.prototype, "editor", void 0);
tslib_1.__decorate([
    Watch('status')
], VOption.prototype, "handleStatusChange", null);
VOption = tslib_1.__decorate([
    Component({
        name: 'VOption',
        components: {
            Editor: UEditor,
            VRadio,
            VCheckBox
        }
    })
], VOption);
export default VOption;
